export default __webpack_public_path__ + "static/media/icon--email.dba35211.svg";